module.exports = "<div class=\"row\" [id]=\"'fila_' + index + '_tta_' + filtros.tta\">\n  <ng-container #rowContainer>\n\n  </ng-container>\n</div>"